"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketInput_1 = require("./DeleteBucketInput");
var DeleteBucketOutput_1 = require("./DeleteBucketOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucket = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucket",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}"
    },
    input: {
        shape: DeleteBucketInput_1.DeleteBucketInput
    },
    output: {
        shape: DeleteBucketOutput_1.DeleteBucketOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucket.js.map